module.exports = __webpack_public_path__ + "static/media/mic.4af3334f.svg";